import { createActionConst } from '../../../utils/action.utils';

export const DEFAULT_CHART_TYPE = 'org-chart';

const CHART_NAMESPACE = 'CHART';

export const INITIAL_CHART_PAGE = createActionConst(CHART_NAMESPACE, 'INITIAL_CHART_PAGE');
export const INITIAL_CHART_EDIT_PAGE = createActionConst(CHART_NAMESPACE, 'INITIAL_CHART_EDIT_PAGE');
export const SELECT_CHART_VERSION = createActionConst(CHART_NAMESPACE, 'SELECT_CHART_VERSION');
export const SELECT_CHART_DRAFT = createActionConst(CHART_NAMESPACE, 'SELECT_CHART_DRAFT');
export const PUBLISH_CHART_VERSION = createActionConst(CHART_NAMESPACE, 'PUBLISH_CHART_VERSION');
export const PUBLISH_CHART_DRAFT = createActionConst(CHART_NAMESPACE, 'PUBLISH_CHART_DRAFT');
export const CREATE_EMPTY_CHART_DRAFT = createActionConst(CHART_NAMESPACE, 'CREATE_EMPTY_CHART_DRAFT');
export const CREATE_DRAFT_FROM_VERSION = createActionConst(CHART_NAMESPACE, 'CREATE_DRAFT_FROM_VERSION');
export const DELETE_CHART = createActionConst(CHART_NAMESPACE, 'DELETE_CHART');
